import React, { useEffect, useState, useRef } from "react";
import { useTable, usePagination } from "react-table";
import { Link } from "react-router-dom";
import * as scentawareApi from "../../services/api/scentaware";
import { CSVLink } from 'react-csv';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useParams } from 'react-router-dom';
import { Modal } from "antd";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Select from 'react-select';
import * as XLSX from 'xlsx';
import { useMemo } from "react";
import { toast } from "react-toastify";

const CustomTable = (
	{
		columns,
		data,
		pagination,
		setPagination,
		loading,
		setCurrentPage,
		setFilter,
		filter,
		// filterOption,
		totalCount,
		type,
		fetchData,
		fetchFormattedData
	}
) => {

	let { id } = useParams();
	const csvLinkRef = useRef(null);
	const [loader, setLoader] = useState(false);
	const [studyNumberLoader, setStudyNumberLoader] = useState(false);
	const [csvHeaders, setCsvHeaders] = useState([]);
	const [openModal, SetOpenModal] = useState(false)
	const [openModals, SetOpenModals] = useState(false)
	const [openDateRangeModals, SetOpenDateRangeModals] = useState(false)
	const [participant, setParticipant] = useState({
		studyNumbers: [],
		userIds: [],
		patientId: [],
		range: '',
		tubeId: '',
		// score: '',
	})

	const [paginationExportData, setExportDataPagination] = useState({
		pageIndex: 1,
		pageSize: totalCount,
		totalCount: totalCount
	});
	let [exportData, setexportData] = useState([])
	let [value, setValue] = useState("")
	let [FromDate, setFromDate] = useState("")
	let [ToDate, setToDate] = useState("")
	let [exportError, setExportError] = useState("")
	// let [studyNumberOption, setStudyNumberOption] = useState([])
	// let [researcherOption, setResearcherOption] = useState([])
	// let [participantIdOption, setParticipantIdOption] = useState([])
	const [selectedFormats, setSelectedFormats] = useState({
		csv: false,
		pdf: false,
	});

	const [filterOption, setFilterOption] = useState({
		studyNumbers: [],
		userIds: [],
		patientId: [],
	})
	useEffect(() => {
		const storedValue = localStorage.getItem('studyNumber');
		if(storedValue){
			participant.studyNumbers = [storedValue]
			setParticipant(participant);
		}
	  }, []);

	useEffect(() => {
		const headers = columns.map(column => ({
			label: column.Header,
			key: column.accessor,
		}));
		setCsvHeaders(headers)
		// // setFilter((state) => ({ ...state, filterBy: columns[0]?.accessor }))
		fetchFilterationOption()
	}, [])

	// useEffect(() => {
	// 	console.log('filterOption', filterOption);
	// 	// if (filterOption?.studyNumbers) {
	// 	// 	const studyNumberOption = [
	// 	// 		{ value: 'selectAll', label: 'Select All' },
	// 	// 		...filterOption?.studyNumbers?.map(patient => ({ value: patient.StudyNumber, label: patient.StudyNumber })),
	// 	// 	];
	// 	// 	setStudyNumberOption(studyNumberOption);
	// 	// }
	// 	// if (filterOption?.userIds) {
	// 	// 	const studyNumberOption = [
	// 	// 		{ value: 'selectAll', label: 'Select All' },
	// 	// 		...filterOption?.userIds?.map(patient => ({ value: patient.Id, label: patient.Id })),
	// 	// 	];
	// 	// 	setResearcherOption(studyNumberOption);
	// 	// }
	// 	// if (filterOption?.patientId) {
	// 	// 	const studyNumberOption = [
	// 	// 		{ value: 'selectAll', label: 'Select All' },
	// 	// 		...filterOption?.patientId?.map(patient => ({ value: patient.ParticipantId, label: patient.ParticipantId })),
	// 	// 	];
	// 	// 	setParticipantIdOption(studyNumberOption);
	// 	// }

	// 	if (filterOption?.studyNumbers) {
	// 		filterOption?.studyNumbers.unshift({ StudyNumber: 'selectAll' })
	// 		// console.log('filterOption?.studyNumbers', filterOption?.studyNumbers);
	// 	}
	// 	if (filterOption?.userIds) {
	// 		filterOption?.userIds.unshift({ Id: 'selectAll' })
	// 		// console.log('filterOption?.userIds', filterOption?.userIds);
	// 	}
	// 	if (filterOption?.patientId) {
	// 		filterOption?.patientId.unshift({ ParticipantId: 'selectAll' })
	// 		// console.log('filterOption?.patientId', filterOption?.patientId);
	// 	}
	// }, [filterOption.studyNumbers, filterOption?.userIds, filterOption?.patientId])

	useEffect(() => {

		if (filterOption?.studyNumbers?.length && !filterOption.studyNumbers.some(e => e.StudyNumber === 'selectAll')) {
			setFilterOption(prev => ({
				...prev,
				studyNumbers: [{ StudyNumber: 'selectAll' }, ...prev.studyNumbers]
			}));
		}
		if (filterOption?.userIds?.length && !filterOption.userIds.some(e => e.Id === 'selectAll')) {
			setFilterOption(prev => ({
				...prev,
				userIds: [{ Id: 'selectAll' }, ...prev.userIds]
			}));
		}
		if (filterOption?.patientId?.length && !filterOption.patientId.some(e => e.ParticipantId === 'selectAll')) {
			setFilterOption(prev => ({
				...prev,
				patientId: [{ ParticipantId: 'selectAll' }, ...prev.patientId]
			}));
		}
	}, [filterOption]);

	const fetchFilterationOption = async (studyNumber = null) => {
		setStudyNumberLoader(true)
		const { data: { data } } = await scentawareApi?.getScentwareFilterOption(studyNumber);
		setFilterOption(data);
		setFilterOption(prev => ({
			...prev,
			studyNumbers: [{ StudyNumber: 'selectAll' }, ...data.studyNumbers],
			userIds: [{ Id: 'selectAll' }, ...data.userIds],
			patientId: [{ ParticipantId: 'selectAll' }, ...data.patientId]
		}));
		setStudyNumberLoader(false)
	}

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		prepareRow,
		page,
		canPreviousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		nextPage,
		previousPage,
		setPageSize,
		// Get the state from the instance
		state: { pageIndex, pageSize },
	} = useTable(
		{
			columns,
			data,
			manualPagination: true,
			initialState: { pageIndex: pagination.pageIndex, pageSize: pagination.pageSize },
			pageCount: Math.ceil(pagination.totalCount / pagination.pageSize) + 1
		},
		usePagination
	);


	const handlePageSizeChange = (e) => {
		const newSize = e.target.value ? Number(e.target.value) : 10;
		setPageSize(newSize);
	};

	useEffect(() => {
		setPagination((state) => ({ ...state, pageIndex: pageIndex ? pageIndex : 1, pageSize: pageSize }))
		setExportDataPagination(prevState => ({
			...prevState,
			pageSize: totalCount
		}));
		setCurrentPage(pageIndex)
	}, [pageIndex, pageSize]);

	const capitalizeFirstChar = str => str.charAt(0).toUpperCase() + str.slice(1);

	const handleExportPDF = () => {
		const doc = new jsPDF({ orientation: 'landscape' });
		const headers = csvHeaders.map(header => header.key);
		const data = exportData.map(row => headers.map(key => row[key]));
		// const title =  type.toUpperCase();
		const title = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
		//doc.text(title, 10, 10);
		doc.setFont('bold');
		doc.setFontSize(20);
		const titleWidth = doc.getStringUnitWidth(title) * doc.internal.getFontSize() / doc.internal.scaleFactor;
		const centerX = (doc.internal.pageSize.width - titleWidth) / 2;
		doc.text(title, centerX, 20);
		doc.setFont('normal');

		// Update headers by capitalizing the first character of each header
		const updatedHeaders = headers.map(header => capitalizeFirstChar(header));

		doc.autoTable({
			head: [updatedHeaders],
			body: data,
			startY: 30,
			margin: { top: 10, right: 10, bottom: 10, left: 10 },
			styles: { cellPadding: 1, fontSize: 8, valign: 'middle', overflow: 'linebreak' },
			headStyles: { fillColor: [100, 100, 255], textColor: 255, halign: 'center' },
			columnStyles: {
				0: { columnWidth: 10 },
				1: { columnWidth: 20 },
				2: { columnWidth: 10 },
				3: { columnWidth: 30 },
				4: { columnWidth: 15 },
				5: { columnWidth: 20 },
				6: { columnWidth: 20 },
				7: { columnWidth: 30 },
				8: { columnWidth: 10 },
				9: { columnWidth: 20 },
				10: { columnWidth: 20 },
				11: { columnWidth: 15 },
				12: { columnWidth: 20 },
				13: { columnWidth: 20 },
				14: { columnWidth: 20 },
			},
			bodyStyles: { rowHeight: 8 },
		});

		doc.save('exported-data.pdf');
	};

	const handleAddParticipantChange = (e) => {
		const { name, value, options } = e.target;

		let newValues;
		if (name == 'studyNumbers' || name == 'userIds' || name == 'patientId') {
			const isSelectAll = Array.from(options).some(option => option.value === 'selectAll' && option.selected);

			if (isSelectAll) {
				// Toggle select all behavior
				const allSelected = Array.from(options).every(option => option.selected || option.value === 'selectAll');
				newValues = allSelected ? [] : Array.from(options).filter(option => option.value !== '').map(option => option.value);
				// newValues = allSelected ? [] : Array.from(options).filter(option => option.value !== 'selectAll').map(option => option.value);
			} else {
				// Handle regular multi-select behavior
				newValues = Array.from(options).filter(option => option.selected).map(option => option.value);
			}

			// if (newValues?.length && !newValues.some(e => e.Id === 'selectAll')) {
			// 	newValues.unshift('selectAll')
			// }

			setParticipant((prevParticipant) => ({
				...prevParticipant,
				[name]: newValues,
			}));
		}
		else {
			setParticipant((prevParticipant) => ({
				...prevParticipant,
				[name]: value,
			}));
		}

		if (name == 'studyNumbers') {
			fetchFilterationOption(newValues)
		}
	};

	const handleSelect = (selectedDates, dateType) => {
		if (dateType === 'from') {
			const fromDate = moment(selectedDates).format('YYYY-MM-DD');
			setFromDate(fromDate)
			setToDate('')
		}
		else {
			const toDate = moment(selectedDates).format('YYYY-MM-DD');
			setToDate(toDate)
		}
	}
	const handleSelectDate = (selectedDate, dateType) => {
		const selected = moment(selectedDate);
		if (dateType === 'from') {
			const fromDate = selected.format('YYYY-MM-DD');
			setFromDate(fromDate);
			setToDate(''); 
		} else {
			if (!FromDate) {
				toast.error("Please select the From Date first.");
				return;
			}
	
			const from = moment(FromDate);
			const maxTo = from.clone().add(1, 'month');
	
			// if (selected.isBetween(from.clone().subtract(1, 'day'), maxTo.clone().add(1, 'day'))) {
			const toDate = selected.format('YYYY-MM-DD');
			setToDate(toDate);
			// } else {
			// 	// toast.error("To Date must be within 1 month from the From Date.");
			// }
		}
	};

	const handleParticipants = async (e) => {
		e.preventDefault();
		const filters = await filterValues()
		setFilter(filters);
		handleCancel();
	};

	const filterValues = () => {
		const allParticipant = {
			...participant,
			FromDate: FromDate,
			ToDate: ToDate
			// createdDateRange: `${FromDate},${ToDate}`
		}

		const filters = {};
		if (allParticipant.patientId) {
			filters.PatientId = allParticipant.patientId;
		}
		if (allParticipant.userIds) {
			filters.UserId = allParticipant.userIds;
		}
		// if (allParticipant.score) {
		//   filterValues.score = allParticipant.score;
		// }
		if (allParticipant.studyNumbers) {
			filters.StudyNumber = allParticipant.studyNumbers;
		}
		if (allParticipant.FromDate && allParticipant.ToDate) {
			filters.createdDateRange = `${allParticipant.FromDate},${allParticipant.ToDate}`;
		}
		if (allParticipant.tubeId) {
			filters.tubeId = allParticipant.tubeId;
		}

		return filters;
	}

	const handleCancel = (e) => {
		SetOpenModal(false)
		// setParticipant({
		// 	studyNumbers: [],
		// 	userIds: [],
		// 	patientId: [],
		// 	range: '',
		// 	score: '',
		// 	tubeId: '',
		// });
		// setFilterOption((state) => ({
		// 	...state,
		// 	userIds: [],
		// 	patientId: [],
		// }))
		setFromDate("");
		setToDate("");
		setValue([]);
	}

	// const openExportModel = async () => {
	// 	try {
	// 		//audioAware,glanceAware,scentAware,grammarAware,wordsAware
	// 		SetOpenModals(true);
	// 		var {
	// 			data: { data },
	// 		} = await scentawareApi?.getScentaware('', paginationExportData, null, '', '');
	// 		const answerRes = await scentawareApi?.getScentawareAnswers();
	// 		const answers = answerRes.data.data;
	// 		const tubeIdData = [];

	// 		data.forEach((el) => {
	// 			let tubeIdVal = el.TubeId;
	// 			let tubeIdArr = tubeIdVal.split(",");

	// 			let selectedAns = el.SelectedAnswer;
	// 			var ans = selectedAns.split(",");

	// 			let scoreList = [];
	// 			let totalScore1 = 0;

	// 			tubeIdArr.forEach((value, index) => {
	// 				let correctAnswerObj = answers.find(
	// 					(x) => parseInt(x.TubeId) == parseInt(value)
	// 				);
	// 				let tubeAnswer =
	// 					correctAnswerObj && correctAnswerObj != "undefined"
	// 						? correctAnswerObj.Answer
	// 						: "";
	// 				let objIndex = scoreList.findIndex((x) => x.tubeId == value);

	// 				if (objIndex != -1) {
	// 					scoreList[objIndex].score += tubeAnswer == ans[index] ? 1 : 0;
	// 				} else {
	// 					let scoreObj = { tubeId: value };
	// 					scoreObj.score = tubeAnswer == ans[index] ? 1 : 0;
	// 					scoreList.push(scoreObj);
	// 				}

	// 				if (tubeAnswer == ans[index]) {
	// 					totalScore1++;
	// 				}
	// 			});

	// 			tubeIdArr.forEach((value, index) => {
	// 				let correctAnswerObj = answers.find(
	// 					(x) => parseInt(x.TubeId) == parseInt(value)
	// 				);
	// 				let tubeAnswer =
	// 					correctAnswerObj && correctAnswerObj != "undefined"
	// 						? correctAnswerObj.Answer
	// 						: "";
	// 				let scoreIndex = scoreList.findIndex((x) => x.tubeId == value);

	// 				let newObj = {
	// 					Id: el.Id,
	// 					TubeId: value,
	// 					TestType: el.TestType,
	// 					TestType: el.TestType,
	// 					StudyNumber: el.StudyNumber,
	// 					PatientId: el.PatientId,
	// 					SessionId: el.SessionId,
	// 					CreatedDate: moment(el.CreatedDate).format("MM/DD/Y HH:mm:ss"),
	// 					// "SelectedAnswer": ans[index],
	// 					SelectedAnswer: el.SelectedAnswer,
	// 					AverageResponseTime: el.AverageResponseTime,
	// 					UserId: el.UserId,
	// 					PatientId: el.PatientId,
	// 					IsStuffyNose: el.IsStuffyNose,
	// 					tubeAnswer: el.CorrectAnswer,
	// 					// "isCorrect": (tubeAnswer == ans[index])? "TRUE":"FALSE",
	// 					isCorrect: el.IsAnswerCorrect,
	// 					IncorrectSmell:
	// 						el.CorrectAnswer != el.SelectedAnswer ? el.CorrectAnswer : "",
	// 					score:
	// 						typeof scoreList[scoreIndex] == "undefined"
	// 							? ""
	// 							: scoreList[scoreIndex].score,
	// 					totalScore: el.TotalScore,
	// 					// totalScore: el.TotalScore + "/" + filtered.length,
	// 					ScanToScanTime: el.ScanToScanTime,
	// 					IsMedication: el.IsMedication,
	// 				};
	// 				tubeIdData.push(newObj);
	// 			});
	// 		});
	// 		setexportData(tubeIdData);

	// 		setLoader(false)
	// 	} catch (error) {
	// 		console.error('Error during export:', error);
	// 		setLoader(false)
	// 		// You can add additional error handling or display error messages here.
	// 	}
	// }

	const handleExportCancel = (e) => {
		SetOpenModals(false)
		handleCancel();
	}

	const handleDateRangeOpen = (e) => {
		const startDate = moment().startOf('month').format('YYYY-MM-DD');
		const endDate = moment().endOf('month').format('YYYY-MM-DD');
		setFromDate(startDate)
		setToDate(endDate)
		SetOpenDateRangeModals(true)
	}
	const handleDateRangeCancel = (e) => {
		SetOpenDateRangeModals(false)
		handleCancel();
	}

	const handleCheckboxChange = (format) => {
		setExportError('')
		setSelectedFormats((prevFormats) => ({
			...prevFormats,
			[format]: !prevFormats[format],
		}));
	};


	const handleExport = async () => {
		if (!selectedFormats.csv && !selectedFormats.pdf) {
			setExportError('Please select a download file type');
			return;
		}
		try {
			setLoader(true);
			const filters = await filterValues();
			const result = await fetchData('', paginationExportData, filters, '', '');
			const data = result?.data || [];
			if (!data || data.length === 0) {
				toast.error('No record found!');
				setLoader(false);
				return;
			}
			setexportData(data);
			SetOpenModals(false);
			handleCancel();
		} catch (error) {
			console.error('Error during export:', error);
			toast.error('We are facing error. Please try again!');
		} finally {
			setLoader(false);
		}
	};


	const handleFormattedExport = async () => {
		try{
			const from = moment(FromDate);
			const maxTo = from.clone().add(1, 'month');
			const toDate = moment(ToDate);
			if (toDate && !toDate.isBetween(from.clone().subtract(1, 'day'), maxTo.clone().add(1, 'day'))) {
				toast.error("To Date must be within 1 month from the From Date.");
				setLoader(false);
				return;
			}
			setLoader(true);
			const filters = await filterValues();
			const { data, totalCount, answers } = await fetchFormattedData('', paginationExportData, filters, '', '');
		  
			if(data.length == 0){
				toast.error("No record found!");
				setLoader(false);
				return;
			}
			let groupedByDate = data.reduce((acc, item) => {
				const date = moment(item.CreatedDate).startOf('day').format('YYYY-MM-DD');
				if (!acc[date]) {
					acc[date] = [];
				}
				acc[date].push(item);
				return acc;
			}, {});

			const wb = XLSX.utils.book_new();
			const Answer = answers.map(x => x.tubeValue);
			const sortedDates = Object.keys(groupedByDate).sort((a, b) => {
				return new Date(a) - new Date(b);
			});
			sortedDates.forEach((date) => {
				const dateData = groupedByDate[date];
				const AnsObjBoolean = {};
				const AnsObjValue = {};
				Answer.forEach(x => {
					AnsObjBoolean[x] = [x];
					AnsObjValue[x] = [x];
				});
		  
				const groupedByPatient = dateData.reduce((acc, item) => {
					const key = item.PatientId;
					if (!acc[key]) acc[key] = [];
					acc[key].push(item);
					return acc;
				}, {});
		  
				const obj = {
					PatientId: ['Participant ID'],
					Age: ['Age'],
					Gender: ['Gender'],
					Medication: ['Medication'],
					StudyNumber: ['Study Number'],
				};
			
				let index = 1;
				Object.entries(groupedByPatient).forEach(([patientId, records]) => {
					const firstRecord = records[0];
					obj.PatientId.push(patientId);
					obj.Age.push(firstRecord.Age || '');
					obj.Gender.push(firstRecord.Gender || '');
					obj.Medication.push(firstRecord.IsMedication || '');
					obj.StudyNumber.push(firstRecord.StudyNumber || '');
			
					records.forEach(record => {
					if (AnsObjBoolean[record.tubeAnswer]) {
						AnsObjBoolean[record.tubeAnswer][index] = record.isCorrect ? 1 : 0;
						AnsObjValue[record.tubeAnswer][index] = record.SelectedAnswer;
					}
					});
					index++;
				});
		  
				const emptyRows = Array(5).fill().map(() => ['']);
				const sheetData = [
					...Object.values(obj),
					...emptyRows,
					...Object.values(AnsObjBoolean),
					...emptyRows,
					...Object.values(AnsObjValue)
				];
			
				const ws = XLSX.utils.aoa_to_sheet(sheetData);
				const safeSheetName = `Scentaware_${date.replace(/[:\\/?*\[\]]/g, '_')}`;
				XLSX.utils.book_append_sheet(wb, ws, safeSheetName);
			});

			const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
			const blob = new Blob([wbout], { type: 'application/octet-stream' });
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = generateTimestampedFilename;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			URL.revokeObjectURL(url);
		}
		catch(error){
			console.log(error)
			toast.error('We are facing error. Please try again!');
			handleCancel();
		}
		setLoader(false);
	  };

	const handleExportExcel = async () => {
		try {
			setLoader(true);
			const { data: excelData } = await fetchData('', { pageIndex: 1, pageSize: 99999 }, {}, '', '');
			if (!excelData || excelData.length === 0) {
				toast.error('No record found!');
				setLoader(false);
				return;
			}
			const wb = XLSX.utils.book_new();
			const ws = XLSX.utils.json_to_sheet(excelData);
			const sheetName = (type.charAt(0).toUpperCase() + type.slice(1)).substring(0, 31);
			XLSX.utils.book_append_sheet(wb, ws, sheetName);
			const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
			const blob = new Blob([wbout], { type: 'application/octet-stream' });
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = `${sheetName}_${new Date().toISOString().slice(0, 10)}.xlsx`;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			URL.revokeObjectURL(url);
		} catch (error) {
			console.log(error);
			toast.error('We are facing error. Please try again!');
		}
		setLoader(false);
	};

	useEffect(() => {
		if (exportData.length > 0) {
			if (selectedFormats.pdf) {
				handleExportPDF()
			}
			if (selectedFormats.csv) {
				csvLinkRef.current.link.click();
			}

			setSelectedFormats({
				csv: false,
				pdf: false
			})
			setexportData([]);
		}
	}, [exportData])

	const handleSelectChange = (selectedOptions, propertyName) => {
		const isSelectAllSelected = selectedOptions.some(option => option.value === 'selectAll');
		let newValues = [];

		if (isSelectAllSelected) {
			const optionsToCompare = filterOption[propertyName]; // Assume filterOption dynamically has the correct options array for each property
			const allOptionsSelected = selectedOptions.length >= optionsToCompare.length;
			if (propertyName == "patientId") {
				newValues = allOptionsSelected ? [] : optionsToCompare.map(option => ({ value: option.ParticipantId, label: option.ParticipantId })); // This might need adjustment based on the property being updated
			}
			if (propertyName == "userIds") {
				newValues = allOptionsSelected ? [] : optionsToCompare.map(option => ({ value: option.Id, label: option.Id })); // This might need adjustment based on the property being updated
			}
			if (propertyName == "studyNumbers") {
				newValues = allOptionsSelected ? [] : optionsToCompare.map(option => ({ value: option.StudyNumber, label: option.StudyNumber })); // This might need adjustment based on the property being updated
			}
		} else {
			newValues = selectedOptions;
		}

		setParticipant(prevParticipant => ({
			...prevParticipant,
			[propertyName]: newValues,
		}));
	}

	const isAllStudySelected = participant?.studyNumbers?.length >= filterOption?.studyNumbers?.length;
	const isAllResearcherSelected = participant?.userIds?.length >= filterOption?.userIds?.length;
	const isAllParticipantSelected = participant?.patientId?.length >= filterOption?.patientId?.length;

	// console.log('participant', participant);
	// console.log('studyNumbers.length', participant.studyNumbers?.length);
	// console.log('researcher.length', participant.userIds?.length);
	// console.log('patientId.length', participant.patientId?.length);

	const generateTimestampedFilename = useMemo(() => {
		const now = new Date();
		const pad = (num) => num.toString().padStart(2, '0');
		const year = now.getFullYear();
		const month = pad(now.getMonth() + 1);
		const day = pad(now.getDate());
		const hours = pad(now.getHours());
		const minutes = pad(now.getMinutes());
		const seconds = pad(now.getSeconds());
		const timestamp = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
		let baseName = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
		return `${baseName}_${timestamp}.csv`;
	}, [])

	  
	return (
		<>
			<section className="page_section ps-lg-4 pe-lg-5">
				<div className="container-fluid">
					<div className="row justify-content-center">
						<div className="col-lg-2 col-md-6 col-sm-12 col-12  d-flex align-items-center">
							<div className="page_title d-flex align-items-center">
								<Link to={`/dashboard/${id ? encodeURIComponent(id) + "?type=clinicalTrialId" : ''}`}>
									<svg width="40" height="40" className="me-3" viewBox="0 0 40 40" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<rect x="39" y="39" width="38" height="38" rx="19" transform="rotate(180 39 39)"
											stroke="#101A36" stroke-width="2" />
										<path
											d="M24.9999 19L17.4099 19L20.7099 15.71C20.8982 15.5217 21.004 15.2663 21.004 15C21.004 14.7337 20.8982 14.4783 20.7099 14.29C20.5216 14.1017 20.2662 13.9959 19.9999 13.9959C19.7336 13.9959 19.4782 14.1017 19.2899 14.29L14.2899 19.29C14.1989 19.3851 14.1275 19.4973 14.0799 19.62C13.9799 19.8635 13.9799 20.1365 14.0799 20.38C14.1275 20.5028 14.1989 20.6149 14.2899 20.71L19.2899 25.71C19.3829 25.8037 19.4935 25.8781 19.6153 25.9289C19.7372 25.9797 19.8679 26.0058 19.9999 26.0058C20.1319 26.0058 20.2626 25.9797 20.3845 25.9289C20.5063 25.8781 20.6169 25.8037 20.7099 25.71C20.8036 25.617 20.878 25.5064 20.9288 25.3846C20.9796 25.2627 21.0057 25.132 21.0057 25C21.0057 24.868 20.9796 24.7373 20.9288 24.6154C20.878 24.4936 20.8036 24.383 20.7099 24.29L17.4099 21L24.9999 21C25.2651 21 25.5195 20.8946 25.707 20.7071C25.8945 20.5196 25.9999 20.2652 25.9999 20C25.9999 19.7348 25.8945 19.4804 25.707 19.2929C25.5195 19.1054 25.2651 19 24.9999 19Z"
											fill="#101A36" />
									</svg>
									Test Logs
								</Link>
							</div>
						</div>
						<div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-lg-0 mt-md-0 mt-3">
							{/* <div className="view_test_button d-flex align-items-center">
								<CSVLink
									data={exportData}
									headers={csvHeaders}
									filename={'sensify.csv'}
									ref={(csvLink) => (csvLinkRef.current = csvLink)}
									style={{ display: 'none' }}
								>
									Download CSV
								</CSVLink>
								<CSVLink data={data} headers={csvHeaders} filename={'sensify.csv'}>
                                    <button className="btn btn-primary bg-white">Export CSV</button>
                                </CSVLink>
                                <button className="btn btn-primary bg-white ms-lg-4 ms-md-4 ms-3" onClick={handleExportPDF}>Export PDF</button>
								<button className="btn btn-primary bg-white ms-lg-4 ms-md-4 ms-3" onClick={openExportModel}>Export</button>
							</div> */}
						</div>
						<div className="col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-end gap-3 mt-lg-0 mt-md-4 mt-3">
							{type !== 'logs' && (
								<>
									<div className="view_test_button d-flex align-items-center">
										<CSVLink
											data={exportData}
											//headers={csvHeaders?.map(header => capitalizeFirstChar(header.key))}
											headers={type == 'scentAware' ?  null : csvHeaders.map(header => ({
												label: capitalizeFirstChar(header.key),
												key: header.key,
											}))}
											filename={generateTimestampedFilename}
											ref={(csvLink) => (csvLinkRef.current = csvLink)}
											style={{ display: 'none' }}
										>
											Download CSV
										</CSVLink>
										{/* <CSVLink data={data} headers={csvHeaders} filename={'sensify.csv'}>
                                    <button className="btn btn-primary bg-white">Export CSV</button>
                                </CSVLink>
                                <button className="btn btn-primary bg-white ms-lg-4 ms-md-4 ms-3" onClick={handleExportPDF}>Export PDF</button> */}
										{type == 'scentAware' && <div className="view_test_button d-flex align-items-center">
											<button className="btn btn-primary bg-white ms-lg-4 ms-md-4 ms-3" onClick={() => { handleDateRangeOpen() }}>Export Formatted</button>
										</div>}
										<button className="btn btn-primary bg-white ms-lg-4 ms-md-4 ms-3" onClick={() => { SetOpenModals(true) }}>Export Raw</button>
										{type === 'trainingData' && (
											<button className="btn btn-primary bg-white ms-lg-4 ms-md-4 ms-3" onClick={handleExportExcel} disabled={loader}>
												{loader ? 'Exporting...' : 'Export Excel'}
											</button>
										)}
										<button className="btn btn-primary bg-white ms-lg-4 ms-md-4 ms-3" onClick={() => { SetOpenModal(true) }}>Apply Filters</button>
									</div>
									{/* <div className="view_test_button d-flex align-items-center"> */}
										{/* <div className="dropdown test_dropdown">
                                    <select className=" btn btn-primary bg-white text-start" onChange={(e) => { setFilter((state) => ({ ...state, filterBy: e.target.value })) }}
                                        defaultValue={filter.filterBy}>
                                        {columns.map(column => {
                                            return (<>
                                                <option value={column.accessor}>{column.Header}</option>
                                            </>)
                                        })
                                        }
                                    </select>
                                </div> */}
									{/* </div> */}
								</>
							)}
							{/* <div className="search_form ms-lg-4 ms-md-4 ms-4 w-100">
                                <form action="">
                                    <div className="input-group">
                                        <button type="button" className="search_button">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                                fill="none">
                                                <path
                                                    d="M21.07 16.83L19 14.71C18.5547 14.2868 17.9931 14.0063 17.3872 13.9047C16.7813 13.8032 16.1589 13.8851 15.6 14.14L14.7 13.24C15.7605 11.8229 16.2449 10.0567 16.0555 8.29684C15.8662 6.537 15.0172 4.91423 13.6794 3.7552C12.3417 2.59618 10.6145 1.98696 8.84565 2.05019C7.07678 2.11341 5.39754 2.84439 4.14596 4.09597C2.89438 5.34755 2.1634 7.0268 2.10017 8.79567C2.03695 10.5645 2.64617 12.2917 3.80519 13.6294C4.96421 14.9672 6.58699 15.8162 8.34683 16.0055C10.1067 16.1949 11.8729 15.7106 13.29 14.65L14.18 15.54C13.8951 16.0996 13.793 16.7346 13.8881 17.3553C13.9831 17.9761 14.2706 18.5513 14.71 19L16.83 21.12C17.3925 21.6818 18.155 21.9974 18.95 21.9974C19.745 21.9974 20.5075 21.6818 21.07 21.12C21.3557 20.8406 21.5828 20.5069 21.7378 20.1386C21.8928 19.7702 21.9726 19.3746 21.9726 18.975C21.9726 18.5754 21.8928 18.1798 21.7378 17.8114C21.5828 17.4431 21.3557 17.1094 21.07 16.83ZM12.59 12.59C11.8902 13.288 10.9993 13.7629 10.0297 13.9549C9.06017 14.1468 8.05549 14.047 7.14259 13.6682C6.2297 13.2894 5.44955 12.6485 4.9007 11.8265C4.35185 11.0046 4.05893 10.0384 4.05893 9.05C4.05893 8.06163 4.35185 7.09544 4.9007 6.27347C5.44955 5.45149 6.2297 4.81062 7.14259 4.43182C8.05549 4.05301 9.06017 3.95325 10.0297 4.14515C10.9993 4.33706 11.8902 4.812 12.59 5.51C13.0556 5.97446 13.4251 6.52621 13.6771 7.13367C13.9292 7.74112 14.0589 8.39233 14.0589 9.05C14.0589 9.70768 13.9292 10.3589 13.6771 10.9663C13.4251 11.5738 13.0556 12.1255 12.59 12.59ZM19.66 19.66C19.567 19.7537 19.4564 19.8281 19.3346 19.8789C19.2127 19.9297 19.082 19.9558 18.95 19.9558C18.818 19.9558 18.6873 19.9297 18.5654 19.8789C18.4436 19.8281 18.333 19.7537 18.24 19.66L16.12 17.54C16.0263 17.447 15.9519 17.3364 15.9011 17.2146C15.8503 17.0927 15.8242 16.962 15.8242 16.83C15.8242 16.698 15.8503 16.5673 15.9011 16.4454C15.9519 16.3236 16.0263 16.213 16.12 16.12C16.213 16.0263 16.3236 15.9519 16.4454 15.9011C16.5673 15.8503 16.698 15.8242 16.83 15.8242C16.962 15.8242 17.0927 15.8503 17.2146 15.9011C17.3364 15.9519 17.447 16.0263 17.54 16.12L19.66 18.24C19.7537 18.333 19.8281 18.4436 19.8789 18.5654C19.9296 18.6873 19.9558 18.818 19.9558 18.95C19.9558 19.082 19.9296 19.2127 19.8789 19.3346C19.8281 19.4564 19.7537 19.567 19.66 19.66Z"
                                                    fill="white" />
                                            </svg>
                                        </button>
                                        <input type="search" className="form-control" placeholder="Search bar" onChange={(e) => { handleSearchFilter(e) }} aria-label="Username"
                                            aria-describedby="basic-addon1" />
                                    </div>
                                </form>
                            </div> */}
						</div>
					</div>
					<div className="row mt-lg-5 mt-md-4 mt-4">
						<div className="col-12">
							<div className="test_table">
								<table className="table m-0" id="tableToExport" {...getTableProps()}>
									<thead>
										{headerGroups.map((headerGroup) => (
											<tr {...headerGroup.getHeaderGroupProps()}>
												{headerGroup.headers.map((column) => (
													<th {...column.getHeaderProps()}>
														{column.render("Header")}
													</th>
												))}
											</tr>
										))}
									</thead>
									{
										loading ? <span>Loading...</span> :
											<tbody {...getTableBodyProps()}>
												{page.map((row) => {
													prepareRow(row);
													return (
														<tr {...row.getRowProps()}>
															{row.cells.map((cell) => (
																<td {...cell.getCellProps()}>{cell.render('Cell')}</td>
															))}
														</tr>
													);
												})}
											</tbody>
									}

								</table>
							</div>
						</div>
						<div className="col-12 mt-lg-3 pt-4">
							<div className="pagination d-flex align-items-center justify-content-between">
								<p className="m-0">Showing <b>{(pagination?.pageIndex - 1) * pagination?.pageSize + 1}-{(pagination?.pageIndex - 1) * pagination?.pageSize + page.length}</b> from <b>{pagination?.totalCount}</b></p>
								<ul className="d-flex align-items-center">

									<div className="pagination-select">
										<select value={pageSize} onChange={handlePageSizeChange}>
											<option value={10}>10</option>
											<option value={25}>25</option>
											<option value={50}>50</option>
											<option value={100}>100</option>
										</select>
									</div>
									<li>
										<div className="previour" onClick={() => previousPage()} disabled={!canPreviousPage}>
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
												fill="none">
												<path
													d="M8.45977 12.71L14.1198 18.36C14.2127 18.4537 14.3233 18.5281 14.4452 18.5789C14.5671 18.6297 14.6978 18.6558 14.8298 18.6558C14.9618 18.6558 15.0925 18.6297 15.2144 18.5789C15.3362 18.5281 15.4468 18.4537 15.5398 18.36C15.726 18.1726 15.8306 17.9192 15.8306 17.655C15.8306 17.3908 15.726 17.1374 15.5398 16.95L10.5898 11.95L15.5398 6.99999C15.726 6.81263 15.8306 6.55918 15.8306 6.29499C15.8306 6.03081 15.726 5.77736 15.5398 5.58999C15.4472 5.49551 15.3367 5.42034 15.2148 5.36884C15.093 5.31734 14.9621 5.29054 14.8298 5.29C14.6975 5.29054 14.5666 5.31734 14.4447 5.36884C14.3228 5.42034 14.2124 5.49551 14.1198 5.58999L8.45977 11.24C8.35827 11.3336 8.27726 11.4473 8.22185 11.5738C8.16645 11.7003 8.13784 11.8369 8.13784 11.975C8.13784 12.1131 8.16645 12.2497 8.22185 12.3762C8.27726 12.5027 8.35827 12.6164 8.45977 12.71Z"
													fill="#0096FF" />
											</svg>
										</div>
									</li>
									<li className="flex align-items-center mx-2">

										{
											(pageIndex == 2 || pageIndex == 1 || pageIndex == 0) &&
											// Display spans around the current page
											[0, 1, 2].map(option => (
												<span
													key={option}
													className={pageIndex == 0 ? option + 1 === pageIndex + 1 ? 'pagination_count mx-2 active' : 'pagination_count  mx-2' : option + 1 === pageIndex ? 'pagination_count mx-2 active' : 'pagination_count  mx-2'}
													onClick={() => gotoPage(option + 1)}
												>
													{option + 1} {/* Adding 1 here to display 1-based indexing */}
												</span>
											))
										}
										{
											pageIndex > 2 &&
											// Display spans around the current page
											[pageIndex - 1, pageIndex, pageIndex + 1].map(option => (
												<span
													key={option}
													className={option === pageIndex ? 'pagination_count mx-2 active' : 'pagination_count  mx-2'}
													onClick={() => gotoPage(option)}
												>
													{option} {/* Adding 1 here to display 1-based indexing */}
												</span>
											))
										}

									</li>
									<li>
										<div className="next" onClick={() => nextPage()} disabled={!canNextPage}>
											{/* <div className="next" disabled={!pagination.totalCount > pageSize * (pageIndex + 1)}> */}
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
												fill="none">
												<path
													d="M15.5402 11.29L9.88023 5.64001C9.78726 5.54628 9.67666 5.47188 9.5548 5.42111C9.43294 5.37035 9.30224 5.34421 9.17023 5.34421C9.03821 5.34421 8.90751 5.37035 8.78565 5.42111C8.66379 5.47188 8.55319 5.54628 8.46023 5.64001C8.27398 5.82737 8.16943 6.08082 8.16943 6.34501C8.16943 6.60919 8.27398 6.86264 8.46023 7.05001L13.4102 12.05L8.46023 17C8.27398 17.1874 8.16943 17.4408 8.16943 17.705C8.16943 17.9692 8.27398 18.2226 8.46023 18.41C8.55284 18.5045 8.66329 18.5797 8.78516 18.6312C8.90704 18.6827 9.03792 18.7095 9.17023 18.71C9.30253 18.7095 9.43342 18.6827 9.55529 18.6312C9.67717 18.5797 9.78761 18.5045 9.88023 18.41L15.5402 12.76C15.6417 12.6664 15.7227 12.5527 15.7781 12.4262C15.8336 12.2997 15.8622 12.1631 15.8622 12.025C15.8622 11.8869 15.8336 11.7503 15.7781 11.6238C15.7227 11.4973 15.6417 11.3836 15.5402 11.29Z"
													fill="#0096FF" />
											</svg>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>

			<Modal
				title="Export files"
				open={openModals}
				onCancel={handleExportCancel}
				footer={null}
				className="add_participend"
			>
				<div className="search_form w-100 text-center">
					<form>
						<div className="row g-3">
							<div>
								<label className="ant-form-item-required form_label text-start w-100 mb-2">Download File</label>
								<div className="d-flex align-items-center gap-3 justify-content-start">
									<div>
										<label>
											<input
												type="checkbox"
												checked={selectedFormats.csv}
												onChange={() => handleCheckboxChange('csv')}
											/>{' '}
											CSV
										</label>
									</div>
									<div>
										<label>
											<input
												type="checkbox"
												checked={selectedFormats.pdf}
												onChange={() => handleCheckboxChange('pdf')}
											/>{' '}
											PDF
										</label>
									</div>
									{
										exportError && <span className="text-danger">{exportError}</span>
									}
								</div>
							</div>
							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label text-start w-100 mb-2">Study Number</label>
								<div className="input-group">
									<select class="form-select"
										name="studyNumbers"
										style={{ height: '55px' }}
										value={(participant.studyNumbers?.length > 1) ? 'selectAll' : participant.studyNumbers}
										aria-label="Default select example"
										onChange={(e) => handleAddParticipantChange(e)}
									>
										{/* <option selected>studyNumber</option> */}
										{/* <option value="selectAll">Select All</option> */}
										{(!filterOption?.studyNumbers || filterOption.studyNumbers.length === 0) && (
											<option disabled value="">
												Loading data...
											</option>
										)}

										{filterOption?.studyNumbers?.map((patient, index) => (
											<option key={index} value={patient.StudyNumber}>
												{patient.StudyNumber}
											</option>
										))}
									</select>
									{/* <Select
										options={studyNumberOption}
										value={isAllStudySelected ? studyNumberOption : participant.studyNumbers}
										onChange={(selectedOptions) => handleSelectChange(selectedOptions, 'studyNumbers')}
										// isMulti
									// closeMenuOnSelect={false}
									/> */}
								</div>
							</div>

							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label text-start w-100 mb-2">Researcher/PI</label>
								<div className="input-group">
									<select className={`form-select ${studyNumberLoader ? 'disabled-select' : ''}`}
										name="userIds"
										style={{
											height: '55px',
										}}
										disabled={studyNumberLoader }
										value={participant.userIds?.length > 2 ? 'selectAll' : participant.userIds}
										aria-label="Default select example"
										onChange={(e) => handleAddParticipantChange(e)}
									>
										{/* <option selected value="">Researcher/PI</option> */}
										{/* <option value="selectAll">Select All</option> */}
										{(!filterOption?.userIds || filterOption.userIds.length === 0) && (
											<option disabled value="">
												Loading data...
											</option>
										)}
										{filterOption?.userIds?.map((patient, index) => (
											<option key={index} value={patient.Id
											}>
												{patient.Id}
											</option>
										))}
									</select>
									{/* <Select
										options={researcherOption}
										value={isAllResearcherSelected ? researcherOption : participant.userIds}
										onChange={(selectedOptions) => handleSelectChange(selectedOptions, 'userIds')}
										isMulti
									// closeMenuOnSelect={false}
									/> */}
								</div>
							</div>
							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label text-start w-100 mb-2"> Participant ID</label>
								<div className="input-group">
									<select className={`form-select ${studyNumberLoader ? 'disabled-select' : ''}`}
										name="patientId"
										style={{
											height: '55px',
										}}

										disabled={studyNumberLoader}
										value={participant.patientId?.length > 2 ? 'selectAll' : participant.patientId}
										aria-label="Default select example"
										onChange={(e) => handleAddParticipantChange(e)}
									>
										{/* <option selected value="">Participent Id</option> */}
										{/* <option value="selectAll">Select All</option> */}
										{((!filterOption?.patientId || filterOption.patientId.length === 0) && filterOption.studyNumbers.length === 0) && (
											<option disabled value="">
												Loading data...
											</option>
										)}

										{filterOption?.patientId?.map((patient, index) => (
											<option key={index} value={patient.ParticipantId}>
												{patient.ParticipantId}
											</option>
										))}
									</select>
									{/* <Select
										options={participantIdOption}
										value={isAllParticipantSelected ? participantIdOption : participant.patientId}
										onChange={(selectedOptions) => handleSelectChange(selectedOptions, 'patientId')}
										isMulti
									// closeMenuOnSelect={false}
									/> */}
								</div>
							</div>

							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label text-start w-100 mb-2">Tube Id</label>
								<div className="input-group">
									<input class="form-select"
										placeholder="Tube Id"
										name="tubeId" type='text'
										value={participant.tubeId}
										onChange={(e) => handleAddParticipantChange(e)} />
								</div>
							</div>

							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label text-start w-100 mb-2">Range From</label>
								<div className="input-group" >
									<input
										type="date"
										placeholder="From Date"
										value={FromDate || ''}
										onChange={(e) => handleSelect(e.target.value, 'from')}
									/>
								</div>
							</div>

							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label text-start w-100 mb-2">Range To</label>
								<div className="input-group" >
									<input
										type="date"
										placeholder="To Date"
										value={ToDate || ''}
										onChange={(e) => handleSelect(e.target.value, 'to')}
										min={FromDate}
									/>
								</div>
							</div>



							<button type="button" onClick={handleExport} className="btn btn-primary mt-3" disabled={loader}>
								{/* <div className="spinner-border" role="status" ></div> */}
								{loader ? (
									<div className="spinner-border" role="status" ></div>
								) : (
									'Download'
								)}
							</button>
						</div>
					</form>
				</div>
			</Modal>

			<Modal
				title={"Filters Results"}
				open={openModal}
				// onOk={false}
				onCancel={handleCancel}
				footer={null}
				className="add_participend"
			>

				<div className="search_form w-100">
					<form
						onSubmit={(e) => handleParticipants(e)}
					>
						<div className="row g-3">

							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label w-100 mb-2">Study Number</label>
								<div className="input-group">
									<select class="form-select"
										name="studyNumbers"
										style={{ height: '55px' }}
										value={ participant.studyNumbers}
										// value={(participant.studyNumbers?.length > 1) ? 'selectAll' : participant.studyNumbers}
										aria-label="Default select example"
										onChange={(e) => handleAddParticipantChange(e)}
									>
										{/* <option selected>studyNumber</option> */}
										{/* <option value="selectAll">Select All</option> */}
										{(!filterOption?.studyNumbers || filterOption.studyNumbers.length === 0) && (
											<option disabled value="">
												Loading data...
											</option>
										)}

										{filterOption?.studyNumbers?.map((patient, index) => (
											<option key={index} value={patient.StudyNumber}>
												{patient.StudyNumber}
											</option>
										))}
									</select>
									{/* <Select
										options={studyNumberOption}
										value={isAllStudySelected ? studyNumberOption : participant.studyNumbers}
										onChange={(selectedOptions) => handleSelectChange(selectedOptions, 'studyNumbers')}
										isMulti
									// closeMenuOnSelect={false}
									/> */}
								</div>
								{/* <div className="input-group">
									<input
										type="text"
										className="form-control"
										name="studyNumbers"
										style={{ height: '55px' }}
										value={participant.studyNumbers}
										placeholder="StudyNumber"
										aria-label="StudyNumber"
										onChange={(e) => handleAddParticipantChange(e)}
									/>
								</div> */}

							</div>

							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label w-100 mb-2">Researcher/PI</label>
								<div className="input-group">
									{/* <input
										type="text"
										className="form-control"
										name="researcher"
										style={{ height: '55px' }}
										value={participant.researcher}
										placeholder="Researcher ID"
										aria-label="ResearcherId"
										onChange={(e) => handleAddParticipantChange(e)}
									/> */}
									<select className={`form-select ${studyNumberLoader ? 'disabled-select' : ''}`}
										name="userIds"
										style={{
											height: '55px',
										}}
										disabled={studyNumberLoader}
										value={(participant.userIds?.length > 2) ? 'selectAll' : participant.userIds}
										aria-label="Default select example"
										onChange={(e) => handleAddParticipantChange(e)}
									>
										{/* <option selected value="">Researcher/PI</option> */}
										{/* <option value="selectAll">Select All</option> */}
										{/* {(!filterOption?.userIds || filterOption.userIds.length === 0) && (
											<option disabled value="">
												Loading data...
											</option>
										)} */}
										{filterOption?.userIds?.map((patient, index) => (
											<option key={index} value={patient.Id
											}>
												{patient.Id}
											</option>
										))}
									</select>
									{/* <Select
										options={researcherOption}
										value={isAllResearcherSelected ? researcherOption : participant.userIds}
										onChange={(selectedOptions) => handleSelectChange(selectedOptions, 'userIds')}
										isMulti
									// closeMenuOnSelect={false}
									/> */}
								</div>
							</div>
							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label w-100 mb-2"> Participant ID</label>
								<div className="input-group">
									<select className={`form-select ${studyNumberLoader ? 'disabled-select' : ''}`}
										name="patientId"
										style={{
											height: '55px',
										}}

										disabled={studyNumberLoader}
										value={(participant.patientId?.length > 2) ? 'selectAll' : participant.patientId}
										aria-label="Default select example"
										onChange={(e) => handleAddParticipantChange(e)}
									>
										{/* <option selected value="">Participent Id</option> */}
										{/* <option value="selectAll">Select All</option> */}
										{/* {(!filterOption?.patientId || filterOption.patientId.length === 0) && (
											<option disabled value="">
												Loading data...
											</option>
										)} */}

										{filterOption?.patientId?.map((patient, index) => (
											<option key={index} value={patient.ParticipantId}>
												{patient.ParticipantId}
											</option>
										))}
									</select>
									{/* <Select
										options={participantIdOption}
										value={isAllParticipantSelected ? participantIdOption : participant.patientId}
										onChange={(selectedOptions) => handleSelectChange(selectedOptions, 'patientId')}
										isMulti
									// closeMenuOnSelect={false}
									/> */}
								</div>
								{/* <div className="input-group">
									<input
										type="text"
										className="form-control"
										name="participentId"
										style={{ height: '55px' }}
										value={participant.participentId}
										placeholder="Participant ID"
										aria-label="ParticipentId"
										onChange={(e) => handleAddParticipantChange(e)}
									/>
								</div> */}
							</div>


							{/* <div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label w-100 mb-2">Range From:</label>
								<div className="input-group" >
									<DatePicker
										placeholderText="From Date"
										selected={FromDate ? new Date(FromDate) : null}
										onChange={(selectedDates) => handleSelect(selectedDates, 'from')} />
								</div>
							</div>

							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label w-100 mb-2">Range To:</label>
								<div className="input-group" >
									<DatePicker
										selected={ToDate ? new Date(ToDate) : null}
										placeholderText="To Date"
										minDate={FromDate ? new Date(FromDate) : null}
										onChange={(selectedDates) => handleSelect(selectedDates, 'to')} />
								</div>
							</div>  */}

							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label w-100 mb-2">Tube Id</label>
								<div className="input-group">
									<input class="form-select"
										placeholder="Tube Id"
										name="tubeId" type='text'
										value={participant.tubeId}
										onChange={(e) => handleAddParticipantChange(e)} />
								</div>
							</div>
							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label w-100 mb-2">Range From</label>
								<div className="input-group" >
									<input
										type="date"
										placeholder="From Date"
										value={FromDate || ''}
										onChange={(e) => handleSelect(e.target.value, 'from')}
									/>
								</div>
							</div>

							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label w-100 mb-2">Range To</label>
								<div className="input-group" >
									<input
										type="date"
										placeholder="To Date"
										value={ToDate || ''}
										onChange={(e) => handleSelect(e.target.value, 'to')}
										min={FromDate}
									/>
								</div>
							</div>



							{/* <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                <label className="ant-form-item-required form_label w-100 mb-2"> Date Range</label>
                                <div className="date_range_ui row">
                                    <div className="col-lg-3 col-md-12 col-sm-12 col-12 d-flex align-items-center">

                                        <label className="ant-form-item-required text-nowrap form_label w-100 mb-lg-0 mb-2">From:</label>
                                    </div>
                                    <div className="col-lg-9 col-md-12 col-sm-12">
                                        <div className="input-group">
                                            <input type="date" name="FromDate" value={participant.FromDate} className="form-control" placeholder="From Date" aria-label="Username"
                                                aria-describedby="basic-addon1" style={{ height: '55px' }}
                                                onChange={(e) => handleAddParticipantChange(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div> */}

							{/* <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                <label className="ant-form-item-required form_label w-100 mb-2"> SensifyUserId</label>
                                <div className="input-group">
                                    <select class="form-select" name="SensifyUserId" style={{ height: '55px' }} value={participant.SensifyUserId} aria-label="Default select example"
                                        onChange={(e) => handleAddParticipantChange(e)}
                                    >
                                        <option selected>SensifyUserId  </option>
                                        <option value="SensifyUserId1">SensifyUserId1</option>
                                        <option value="SensifyUserId2">SensifyUserId2</option>
                                        <option value="SensifyUserId3">SensifyUserId3</option>
                                    </select>
                                </div>
                            </div> */}

							{/* <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                <label className="ant-form-item-required form_label w-100 mb-2"> </label>
                                
                                <div className="date_range_ui row">
                                    <div className="col-lg-3 col-md-12 col-sm-12 col-12 d-flex align-items-center">

                                        <label className="ant-form-item-required form_label w-100 mb-lg-0 mb-2">To:</label>
                                    </div>
                                    <div className="col-lg-9 col-md-12 col-sm-12">
                                        <div className="input-group">
                                    <input type="date" name="ToDate" value={participant.ToDate} className="form-control" placeholder="ToDate" aria-label="Username"
                                        aria-describedby="basic-addon1" style={{ height: '55px' }}
                                        onChange={(e) => handleAddParticipantChange(e)}
                                    />
                                        </div>
                                    </div>
                                </div>
                            </div> */}


							{/* <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                <label className="ant-form-item-required form_label w-100 mb-2">Range:</label>
                                <div className="input-group" >
                                    <DatePicker
                                        multiple
                                        value={value}
                                        dateSeparator=" to "
                                        onChange={handleSelect}
                                        className="form-control" 
                                    />
                                </div>
                            </div> */}
							{/* <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                <label className="ant-form-item-required form_label w-100 mb-2">Score:</label>
                                <div className="input-group">
                                    <input type="text" name="score" value={participant.score} className="form-control" placeholder="score" aria-label="Username"
                                        aria-describedby="basic-addon1" style={{ height: '55px' }}
                                        onChange={(e) => handleAddParticipantChange(e)}
                                    />
                                </div>
                            </div> */}


							<div className="col-12 d-flex align-items-center justify-content-end">
								<button type="submit" className="btn btn-primary text-white">Apply Filter</button>
							</div>
						</div>
					</form>

				</div>
			</Modal>

			<Modal
				title="Export files"
				open={openDateRangeModals}
				onCancel={handleDateRangeCancel}
				footer={null}
				className="add_participend"
			>
				<div className="search_form w-100 text-center">
					<form className="d-flex justify-content-center w-100">
						<div className="row g-3 w-100">
							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label text-start w-100 mb-2">Range From</label>
								<div className="input-group" >
									<input
										type="date"
										value={FromDate}
										onChange={(e) => handleSelectDate(e.target.value, 'from')}
									/>
								</div>
							</div>

							<div className="col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="ant-form-item-required form_label text-start w-100 mb-2">Range To</label>
								<div className="input-group" >
									<input
										type="date"
										value={ToDate}
										onChange={(e) => handleSelectDate(e.target.value, 'to')}
										min={FromDate} 
									/>
								</div>
							</div>

							<div className="col-12">
								<button type="button" onClick={handleFormattedExport} className="btn btn-primary mt-3 w-100" disabled={loader}>
									{/* <div className="spinner-border" role="status" ></div> */}
									{loader ? (
										<div className="spinner-border" role="status" ></div>
									) : (
										'Download'
									)}
								</button>
							</div>
						</div>
					</form>
				</div>
			</Modal>
		</>
	)
};

export default CustomTable;